export const formatPrice = Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
  minimumFractionDigits: 2,
}).format;

export const formatStripePrice = (price: string | number) =>
  formatPrice(Number(price) / 100);
